/**
 * Veeso User API definitions
 */

import { defHTTP } from '../../api-builder';
import type { UserInfo, UpdateUserRequest, UpdateUserResponse } from './types';

/**
 * User API definitions for use with apiBuilder
 */
export const userAPIDefinitions = {
  /**
   * Get current user info
   */
  getUserInfo: defHTTP<void, UserInfo>('GET', '/user/info'),

  /**
   * Update current user
   */
  updateUser: defHTTP<UpdateUserRequest, UpdateUserResponse>('PUT', '/user'),
};
